import React from "react";
import { convertToHTML } from "draft-convert";
import { Formik } from "formik";
import * as Yup from "yup";

import {
  Grid,
  createStyles,
  makeStyles,
  TextField,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Box,
} from "@material-ui/core";

import { POST_UPDATE_COUNCIL } from "../../../services/options";
import { SelectApi } from "../../../Components/SelectsApi";
import { useSnackbar } from "notistack";
import api from "../../../services/Api";
import { ButtonSuccess } from "../../../Components/ButtonSuccess";
import DefaultModal, {
  DefaultModalActions,
  DefaultModalContent,
} from "../../../Components/DefaultModal";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "grid",
      [theme.breakpoints.up("xs")]: {
        width: 380,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("sm")]: {
        width: 450,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("md")]: {
        width: 500,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("lg")]: {
        width: 500,
        padding: theme.spacing(0, 1, 0, 1),
      },
      [theme.breakpoints.up("xl")]: {
        width: 520,
        padding: theme.spacing(0, 1, 0, 1),
      },
    },
  })
);

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Obrigatório"),
});

export default function NewEdit({ data, setData, open, setOpen, updateData }) {
  const { enqueueSnackbar } = useSnackbar();

  const close = () => {
    setOpen(false);
  };

  const submit = async (values, { setSubmitting }) => {
    const buffer = {
      id: data.id,
      name: values.name,
    };

    await api(POST_UPDATE_COUNCIL(buffer))
      .then((r) => {
        const { data } = r;
        if (data.status === "success") {
          updateData();
          setData({
            id: data.id,
            name: values.name,
          });
          setSubmitting(false);
          close();
          enqueueSnackbar("Vereador atualizado com sucesso", {
            variant: "success",
          });
        } else {
          setSubmitting(false);
          enqueueSnackbar("Erro ao atualizar vereador", { variant: "error" });
        }
      })
      .catch((e) => {
        setSubmitting(false);
        enqueueSnackbar(`Erro ${e.message}`, { variant: "error" });
      });
  };

  return (
    <DefaultModal open={open} handleClose={setOpen} title="Editar Vereador">
      <Formik
        initialValues={data}
        validationSchema={validationSchema}
        onSubmit={submit}
      >
        {(props) => <Forms {...props} />}
      </Formik>
    </DefaultModal>
  );
}

const Forms = (props) => {
  const classes = useStyles();
  const {
    values,
    touched,
    errors,
    isSubmitting,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = props;

  return (
    <form onSubmit={handleSubmit} noValidate>
      <DefaultModalContent dividers>
        <Grid container className={classes.root} spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              maxRows={5}
              variant="outlined"
              size="small"
              id="name"
              label="Nome"
              name="name"
              autoFocus
              inputProps={{ autoComplete: "off" }}
              onChange={handleChange}
              value={values.name}
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
            />
          </Grid>
        </Grid>
      </DefaultModalContent>
      <DefaultModalActions style={{ margin: "0.5rem" }}>
        <ButtonSuccess
          style={{ width: 110 }}
          variant="contained"
          color="primary"
          type="submit"
          success={false}
          loading={isSubmitting}
        >
          {" "}
          Salvar
        </ButtonSuccess>
      </DefaultModalActions>
    </form>
  );
};
